import React, { FC, useState } from 'react';
import { Layout } from 'antd';
import Column from 'antd/lib/table/Column';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { QueryKey } from 'api/queryKey';
import { Content } from 'common/StyledComponents';
import { Header } from 'common/components/Header';
import { NumberedTable } from 'common/components/NumberedTable';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useRole } from 'common/hooks/useRole';
import { commonPaginationConfig, initialPageParams } from 'models/page';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { NewAdditionalDeviceRoute } from 'routes';

const mapDeviceTypeToLabel = (deviceType?: string | null) => {
  if (deviceType === 'OXIMETER') {
    return 'OXY';
  }

  if (deviceType === 'BP_MONITOR') {
    return 'BPM';
  }

  return deviceType !== null && deviceType !== undefined && deviceType !== ''
    ? deviceType
    : '--';
};

export const AdditionalDevicesPage: FC = () => {
  const [pageMetaData, setPageMetaData] = useState(initialPageParams);
  const intlMessage = useFormatMessage();
  const { isSuperAdmin } = useRole();

  const { data, isFetching } = useQuery(
    [QueryKey.SuperAdminAdditionalDevicesList, pageMetaData],
    () =>
      BusinessPartnersAPI.fetchAdditionalDevicesForSuperAdmin({
        ...pageMetaData,
      }),
    {
      enabled: isSuperAdmin,
      keepPreviousData: true,
    }
  );

  const paginationConfig = {
    ...commonPaginationConfig,
    current: pageMetaData?.page,
    pageSize: data?.size,
    total: data?.totalElements,
    onChange: (page: number, pageSize?: number) =>
      setPageMetaData((prev) => ({
        ...prev,
        page,
        ...(pageSize && { pageSize }),
      })),
  };

  return (
    <Layout>
      <Content>
        <Header
          title={intlMessage({ id: 'additionalDevices' })}
          extra={[
            isSuperAdmin ? (
              <Link
                id="button-add-device"
                className="ant-btn ant-btn-primary"
                key={NewAdditionalDeviceRoute}
                to={NewAdditionalDeviceRoute}
              >
                {intlMessage({ id: 'devices.addNew' })}
              </Link>
            ) : null,
          ]}
        />
        <NumberedTable
          rowKey="id"
          loading={isFetching}
          dataSource={data?.content}
          pagination={paginationConfig}
          scroll={{ x: 'auto' }}
        >
          <Column
            title={intlMessage({ id: 'deviceSerialNumber' })}
            dataIndex="serialNumber"
            render={(value) => (value !== null && value !== '' ? value : '--')}
          />
          <Column
            title={intlMessage({ id: 'deviceType' })}
            dataIndex="deviceType"
            render={(value) => mapDeviceTypeToLabel(value)}
          />
          <Column
            title={intlMessage({ id: 'partner' })}
            dataIndex="partnerName"
            render={(value) => (value !== null && value !== '' ? value : '--')}
          />
          <Column
            key="actions"
            title={intlMessage({ id: 'actions' })}
            align="right"
            render={() => null}
          />
        </NumberedTable>
      </Content>
    </Layout>
  );
};
